<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <template v-if="!tree.checkDepartment">
    <fh-person position="bl" :maxTagCount="2" :item="objData" @cb="getVal" trigger-type="close" />
  </template>

  <xl-tree-member-modal v-else :leaveStatus="leaveStatus" :memberNumber="memberNumber" :disabled="disabled" :tree="tree" :depart="(objData && objData?.departList) || []" :user="(objData && objData?.userList) || []" @cb="getVal">
    <div class="comp-xl-member">
      <div :class="{ 'btn-ipt': true, disabled: disabled }" v-if="!objData || (objData.departList?.length === 0 && objData.userList?.length === 0)">
        <span class="xl-member-place-holder">{{ subcol?.placeholder || $t('请选择部门或人员') }}</span>
        <icon-down class="del-icon" />
      </div>
      <div class="btn-ipt" v-else>
        <div class="choosed-tags">
          <div class="choose-tag" v-if="objData?.departList?.length != 0">
            {{ objData?.departList[0]?.departmentName }}
            <icon-close class="del-icon" @click.stop="clearDepartment(objData?.departList[0])" />
            <i class="el-icon-close"></i>
          </div>
          <div class="choose-tag" v-if="objData?.userList?.length != 0 && objData?.departList?.length == 0">
            {{ objData?.userList[0]?.userName }}
            <icon-close @click.stop="clearUser(objData?.userList[0])" />
          </div>
          <p class="tag-plus" v-if="objData?.departList?.length + objData?.userList?.length > 1">+{{ objData?.departList?.length + objData?.userList?.length - 1 }}...</p>
        </div>
        <icon-close class="del-icon" @click.stop="clearAll" />
      </div>
    </div>
  </xl-tree-member-modal>
</template>

<script setup>
import { ref, computed, watchEffect } from 'vue';
const props = defineProps({
  subcol: {
    type: Object,
    default() {
      return {};
    }
  },
  disabled: {
    type: Boolean,
    default: false
  },
  memberNumber: {
    type: Number,
    default: 0
  },
  leaveStatus: {
    type: Number,
    default: 0
  }
});
const emits = defineEmits(['cb']);
console.log(18, props.subcol, props.subcol?.tree);
const tree = computed(() => Object.assign({}, { ...(props.subcol?.tree || {}) }));
const o = ref({});
const objData = ref();
watchEffect(() => {
  objData.value = props.subcol?.value;
});
// 返回值
const emitData = () => {
  if (objData.value && (objData.value.departList?.length || objData.value.userList?.length)) {
    o.value[props.subcol.name] = objData.value;
  } else {
    o.value[props.subcol.name] = undefined;
  }
  console.log(31, o.value);
  emits('cb', o.value);
};
// 获取值
const getVal = (v) => {
  console.log(33, v);
  objData.value = v || {};
  emitData();
};

const clearDepartment = () => {
  console.log(objData.value);
  objData.value && objData.value.departList.shift();
  emitData();
};
const clearUser = () => {
  objData.value && objData.value?.userList.shift();
  emitData();
};
const clearAll = () => {
  objData.value = { departList: [], userList: [] };
  emitData();
};
defineExpose({
  clearAll
});
//清除所有选中的
// const handleDel = () => {
//   objData.value = { departList: [], userList: [] };
//   this.getVal(objData.value);
// };
</script>
<style scoped lang="less">
@import './xl-member.less';
</style>
